export default {
  OPEN_BUY_SELL_MODAL: 'OpenBuySellModal',
  BUY_NOW_BUTTON: 'BuyNow',
  BUY_TAB: 'BuyTab',
  SELL_TAB: 'SellTab',
  BUY_SELL_CLOSED: 'CloseModal',
  BUY_INPUT: 'BuyInput',
  SELL_INPUT: 'SellInput',
  BUY_W_SIMPLEX: 'BuyWithSimplex',
  BUY_W_SIMPLEX_SUCCESS: 'BuyWithSimplexSuccess',
  BUY_W_SIMPLEX_FAILED: 'BuyWithSimplexFailed',
  BUY_W_MOONPAY: 'BuyWithMoonpay',
  BUY_W_MOONPAY_SUCCESS: 'BuyWithMoonpaySuccess',
  BUY_W_MOONPAY_FAILED: 'BuyWithMoonpayFailed',
  SELL_WITH_MOONPAY: 'SellWithMoonpay',
  SELL_WITH_MOONPAY_SUCCESS: 'SellWithMoonpaySuccess',
  SELL_WITH_MOONPAY_FAILED: 'SellWithMoonpayFailed',
  BUY_W_TOPPER: 'BuyWithTopper',
  BUY_W_TOPPER_SUCCESS: 'BuyWithTopperSuccess',
  BUY_W_TOPPER_FAILED: 'BuyWithTopperFailed',
  BUY_PROVIDER_SELECTED: 'BuyWithProviderSelected'
};
